<div #staffHeader fxLayout="row" class="staff-title">
  <div fxLayoutAlign="start center" fxLayoutGap="10px" fxFlex="grow">
    <!-- user-location -->
    @if (locations) {
      <div class="nav-links">
        <i
          class="fa fa-map-marker"
          aria-hidden="true"
          style="font-size: 1em; margin-left: 15px; margin-right: 5px"
        ></i>
        <select
          #select
          title="Select Home Location"
          [(ngModel)]="selectedLocation"
          (ngModelChange)="updateLocation($event)"
        >
          @for (loc of locations; track loc) {
            <option [ngValue]="loc">
              {{ loc.name }}
            </option>
          }
        </select>
      </div>
    }

    <!-- Staff Breadcrumb -->
    <div class="bread-links">
      <a tabindex="0" (agInteract)="openStaffMenu()">
        <i class="fa fa-link" aria-hidden="true"></i
        ><span> {{ pageLabel ?? fullLabel ?? 'Staff Menu' }}</span>
      </a>
    </div>

    <div class="bread-links">
      @for (
        quickItem of quickMenuService.quickMenuItems$ | async;
        track quickItem;
        let i = $index
      ) {
        <a
          class="quicklinks-color"
          tabindex="0"
          [matTooltip]="quickItem | quickLinkLabel"
          (agInteract)="openQuickLink(quickItem)"
        >
          <span class="quick-hotkey badge badge-pill">{{ i === 9 ? '0' : i + 1 }}</span>
        </a>
      }
      @if (staffHistory?.length) {
        <a tabindex="0" (agInteract)="openLastStaffHistory()"
          ><span class="quick-hotkey badge badge-pill">L</span>
        </a>
      }
    </div>
  </div>
  <div fxLayoutAlign="end center">
    <!-- close iframe module -->
    <div title="Close" class="close-staff">
      <i
        id="staffClose"
        class="fa fa-lg fa-times-circle"
        aria-hidden="true"
        tabindex="0"
        (agInteract)="closeStaffModule()"
      ></i>
    </div>
  </div>
</div>
